module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOCAYAAABO3B6yAAABH0lEQVQ4EcXBwRGEMBADwVEwRvmHswRjHdaPKv7XLf5MexH+SHsR/kh7ER66Q1m8TCiLmvDJoiaUxacJRy5xaC/CQ3coi5cJZVETPlnUhLL4NOHIJQ7tRXjoDi8WNaEsakJZfJpQFjWhLGrCkUsc2ovw0B1eLGpCWdSEsvg0oSxqQlnUhCOXOLQX4aE7lEVNeLGoCZ8sakJZ1ISyqAlHLnFoL8JDdyiLmvBiURM+WdSEsqgJZVETjlzi0F6Eh+5QFi8TyqImlMWnCWVRE8qiJhy5xKG9CA/doSxeJpRFTSiLTxPKoiaURU04colDexEeukNZvEwoi5rwyeJlQlnUhLI4Ekp7ER66Q1m8TCiLmvDJ4mVCWdSEsjgSSnsR/ugHpqeXyYi2Z8kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/new.png
// module id = 221
// module chunks = 0